import { createFileRoute, Link } from "@tanstack/react-router";
import { AuthShell } from "@/components/auth-shell";
import { Button } from "@/components/ui/button";
import { lovable } from "@/integrations/lovable/index";
import { toast } from "sonner";

export const Route = createFileRoute("/signup")({
  component: SignupPage,
  head: () => ({
    meta: [
      { title: "Request access — WMS" },
      { name: "description", content: "Accounts are provisioned by your administrator." },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Request access — WMS" },
      { property: "og:description", content: "Accounts are provisioned by your administrator." },
    ],
  }),
});

function SignupPage() {
  const onGoogle = async () => {
    const result = await lovable.auth.signInWithOAuth("google", {
      redirect_uri: `${window.location.origin}/`,
    });
    if (result.error) toast.error(result.error.message ?? "Sign-in failed");
  };
  return (
    <AuthShell title="Create Your Workspace" subtitle="Sign in with Google to provision a new tenant in one step">
      <div className="space-y-4 text-center">
        <Button className="w-full" onClick={onGoogle}>Continue with Google</Button>
        <p className="text-xs text-muted-foreground">
          New accounts go straight to workspace setup. No admin approval required.
        </p>
        <p className="text-sm text-muted-foreground">
          Already have an account?{" "}
          <Link to="/login" className="text-primary hover:underline">Sign in</Link>
        </p>
      </div>
    </AuthShell>
  );
}